// extracted by mini-css-extract-plugin
export var alternate = "_13-h";
export var black = "_13-3";
export var blue = "_13-d";
export var blueLight = "_13-c";
export var brand = "_13-7";
export var error = "_13-9";
export var gray = "_13-6";
export var grayBlue = "_13-b";
export var iconWrapper = "_13-4";
export var indigo = "_13-e";
export var orange = "_13-g";
export var pink = "_13-f";
export var primary = "_13-0";
export var purple = "_13-8";
export var success = "_13-5";
export var warning = "_13-a";
export var white = "_13-1";
export var whiteSuccess = "_13-2";